<script>
import { v4 as uuidv4 } from 'uuid';
import Multiselect from "vue-multiselect";
import * as categoryService from '../../../components/service/category.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: Array,
        required: true,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Multiselect     
    },
    data() {
        return {
            value: this.item_value,
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false
        };
    },   
    methods: {
        addNewStaff() {
            this.value.push({
                id: uuidv4(),
                member: {},
            });
        },
        removeStaff(val) {
            this.value = this.value.filter(x => x.id != val.id)
        },
        async getOptions() {
            let filter = {
                "where": {
                "name": "PCN Team",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)
            let pages = data[0].pages;
            if(pages) this.options = pages;
        },
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    mounted() {
        this.item.display = false
        this.getOptions();
    },
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <div v-for="item of value" :key="item.id">
            <div class="d-flex mb-2">
                <multiselect
                    track-by="title"
                    label="title"
                    v-model="item.member"
                    :options="options"
                    :searchable="options.length > 5 ? true : false"
                    :close-on-select="true"
                    :show-labels="false"
                    :placeholder="'Select Staff Member'"
                    :allow-empty="false"
                    :preselectFirst="true"
                    open-direction="bottom"
                >
                </multiselect>
                <a class="font-size-14 mb-2 ml-3 font-weight-medium align-self-sm-center" role="button" style="color: #da3f3f"
                v-on:click="removeStaff(item)">Remove</a>      
            </div>
        </div>
        <a
        class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer"
        @click="addNewStaff">+ Add Item</a>   
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



